import './ccf-work-history-icon.module.scss';
import { SvgIcon, SvgIconProps } from '@mui/material';

/* eslint-disable-next-line */
export interface CcfWorkHistoryIconProps extends SvgIconProps {
  bgColor?: string;
  viewBox?: string;
}
/**
 * component used to display work history icon
 * @param props - CcfWorkHistoryIconProps
 * @example - <CcfWorkHistoryIcon />
 * @returns SVG of work history icon
 */
export function CcfWorkHistoryIcon(props: CcfWorkHistoryIconProps) {
  return (
    <SvgIcon
      {...props}
      width="24"
      height="24"
      viewBox={props?.viewBox || '-2 -4 24 24'}
      fill="none"
    >
      <g clipPath="url(#clip-Work_History)">
        <path
          d="M10.7 1C8.79999 1 6.89999 1.61364 5.39999 2.84091C4.09999 3.86364 2.99999 5.39773 2.49999 6.93182L2.09999 6.21591C1.89999 6.01136 1.79999 5.90909 1.59999 5.80682C1.49999 5.80682 1.39999 5.80682 1.39999 5.80682C1.29999 5.80682 1.09999 5.80682 0.999993 5.90909C0.499993 6.11364 0.399993 6.625 0.599992 7.03409L1.99999 9.59091C2.09999 9.79545 2.19999 9.89773 2.39999 10C2.59999 10.1023 2.79999 10 2.99999 9.89773L5.49999 8.46591C5.79999 8.46591 5.89999 8.26136 5.99999 8.05682C5.99999 7.85227 5.99999 7.54545 5.89999 7.34091C5.79999 7.13636 5.59999 7.03409 5.39999 6.93182C5.19999 6.93182 4.99999 6.93182 4.79999 7.03409L3.99999 7.44318C4.99999 4.57955 7.69999 2.73864 10.7 2.73864C14.6 2.73864 17.8 6.01136 17.8 10C17.8 13.9886 14.6 17.2614 10.7 17.2614C8.79999 17.2614 6.99999 16.5455 5.69999 15.1136C5.39999 14.8068 4.89999 14.8068 4.49999 15.1136C4.19999 15.4205 4.19999 16.0341 4.49999 16.3409C6.19999 18.0795 8.39999 19 10.7 19C15.5 19 19.5 15.0114 19.5 10C19.5 4.98864 15.6 1 10.7 1Z"
          fill="#333333"
        ></path>
        <path
          d="M10.1999 5.70459C9.7999 5.70459 9.3999 6.11368 9.3999 6.52277V11.0227C9.3999 11.4318 9.7999 11.8409 10.1999 11.8409H13.8999C14.2999 11.8409 14.6999 11.4318 14.6999 11.0227C14.6999 10.6136 14.2999 10.2045 13.8999 10.2045H10.9999V6.52277C10.9999 6.11368 10.5999 5.70459 10.1999 5.70459Z"
          fill="#333333"
        ></path>
        <path
          d="M10.7 1C8.79999 1 6.89999 1.61364 5.39999 2.84091C4.09999 3.86364 2.99999 5.39773 2.49999 6.93182L2.09999 6.21591C1.89999 6.01136 1.79999 5.90909 1.59999 5.80682C1.49999 5.80682 1.39999 5.80682 1.39999 5.80682C1.29999 5.80682 1.09999 5.80682 0.999993 5.90909C0.499993 6.11364 0.399993 6.625 0.599992 7.03409L1.99999 9.59091C2.09999 9.79545 2.19999 9.89773 2.39999 10C2.59999 10.1023 2.79999 10 2.99999 9.89773L5.49999 8.46591C5.79999 8.46591 5.89999 8.26136 5.99999 8.05682C5.99999 7.85227 5.99999 7.54545 5.89999 7.34091C5.79999 7.13636 5.59999 7.03409 5.39999 6.93182C5.19999 6.93182 4.99999 6.93182 4.79999 7.03409L3.99999 7.44318C4.99999 4.57955 7.69999 2.73864 10.7 2.73864C14.6 2.73864 17.8 6.01136 17.8 10C17.8 13.9886 14.6 17.2614 10.7 17.2614C8.79999 17.2614 6.99999 16.5455 5.69999 15.1136C5.39999 14.8068 4.89999 14.8068 4.49999 15.1136C4.19999 15.4205 4.19999 16.0341 4.49999 16.3409C6.19999 18.0795 8.39999 19 10.7 19C15.5 19 19.5 15.0114 19.5 10C19.5 4.98864 15.6 1 10.7 1Z"
          stroke="#333333"
          stroke-width="0.5"
        ></path>
        <path
          d="M10.1999 5.70459C9.7999 5.70459 9.3999 6.11368 9.3999 6.52277V11.0227C9.3999 11.4318 9.7999 11.8409 10.1999 11.8409H13.8999C14.2999 11.8409 14.6999 11.4318 14.6999 11.0227C14.6999 10.6136 14.2999 10.2045 13.8999 10.2045H10.9999V6.52277C10.9999 6.11368 10.5999 5.70459 10.1999 5.70459Z"
          stroke="#333333"
          stroke-width="0.5"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_10171_891">
          <rect width="20" height="20" fill="white"></rect>
        </clipPath>
      </defs>
    </SvgIcon>
  );
}

export default CcfWorkHistoryIcon;
